import { Global } from '@emotion/core'
import { ReactElement, ReactNode } from 'react'
import ReactDOM from 'react-dom'

import { useIsDemoInvoiceModalOpen } from '../../hooks/useIsDemoInvoiceModalOpen'
import { DemoInvoiceBanner } from '../DemoInvoiceBanner'
import * as Styled from './styles'

interface DemoInvoiceLayoutProps {
  children: ReactNode
  onClose: () => void
  onReset: () => void
}

export const DemoInvoiceLayout = ({ children, onClose, onReset }: DemoInvoiceLayoutProps): ReactElement => {
  const isDemoInvoiceModalOpen = useIsDemoInvoiceModalOpen()

  return ReactDOM.createPortal(
    <Styled.FullScreenFrame>
      {isDemoInvoiceModalOpen && <Global styles={Styled.demoInvoiceModalWrapperStyles} />}
      <DemoInvoiceBanner onClose={onClose} onReset={onReset} />
      <Styled.ContentPanel>
        <Styled.ContentColumn>{children}</Styled.ContentColumn>
        {isDemoInvoiceModalOpen && <Styled.PanelOverlay />}
      </Styled.ContentPanel>
    </Styled.FullScreenFrame>,
    document.body,
  )
}
